import { render, staticRenderFns } from "./KarmaCatalogueViewInfo.vue?vue&type=template&id=12c5865e&"
import script from "./KarmaCatalogueViewInfo.vue?vue&type=script&lang=js&"
export * from "./KarmaCatalogueViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports